import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import TimeField from 'react-simple-timefield'
import { useTranslation } from 'react-i18next'

import form from '../../../form'
import AirportPicker from '../airport-picker'
import AircraftPicker from './aircraft-picker'

const FlightForm = props => {
  const timeOptions = []
  const d = new Date()
  const h = d.getHours()
  const m = d.getMinutes()
  for (let i = 0; i < 24; i++) {
    timeOptions.push(
      <option key={2 * i} selected={h === i - 1 && m >= 30}>
        {i < 10 ? `0${i}:00` : `${i}:00`}
      </option>
    )
    timeOptions.push(
      <option key={2 * i + 1} selected={h === i - 1 && m < 30}>
        {i < 10 ? `0${i}:30` : `${i}:30`}
      </option>
    )
  }

  const paxOptions = []
  for (let i = 2; i < 20; i++) {
    paxOptions.push(<option key={i}>{i}</option>)
  }
  paxOptions.push(<option key={20}>19+</option>)

  const wrapper = useRef(null)
  useEffect(() => {
    form(wrapper.current)
  }, [])

  const [hovered, setHovered] = useState(false)
  const [time, setTime] = useState(`${h}:${m}`)

  const aircraftPickerDropdownClass = props.withRightButton
    ? 'ticket__drop-down--compensate-right'
    : ''

  const { t } = useTranslation()

  return (
    <div
      className={classnames([
        'ticket-landing__container ticket-landing__container--main',
        { 'ticket-landing__container--hovered': hovered },
        props.className,
      ])}
      ref={wrapper}
    >
      <label
        className='ticket__label ticket__label--from input-block'
        data-validateable-block
      >
        <AirportPicker
          name={`flights_${props.flightIndex}_from`}
          placeholder={t('From')}
          required
          data-validateable-input
          defaultValue={props.defaultFrom}
          value={props.from}
          onChange={props.onFromChange}
          readOnly={props.disableFromTo}
          selectClassName='ticket__input ticket__input--from'
        />
        <div className='input-error'>{t('This field is required')}</div>
      </label>
      <label
        className='ticket__label ticket__label--to input-block'
        data-validateable-block
      >
        <AirportPicker
          name={`flights_${props.flightIndex}_to`}
          placeholder={t('To')}
          required
          data-validateable-input
          defaultValue={props.defaultTo}
          value={props.to}
          onChange={props.onToChange}
          readOnly={props.disableFromTo}
          selectClassName='ticket__input ticket__input--from'
        />
        <div className='input-error'>{t('This field is required')}</div>
      </label>
      <label
        className='ticket__label ticket__label--date ticket__label--icon-left input-block'
        data-validateable-block
      >
        <input
          className='ticket__input ticket__input--date input-field'
          name={`flights_${props.flightIndex}_date`}
          placeholder={t('Date')}
          required
          type='date'
          data-validateable-input
        />
        <div className='input-error'>{t('This field is required')}</div>
      </label>

      <div className='ticket__input-time-container'>
        <div className='ticket__input-time-wrapper'>
          <TimeField
            input={
              <input
                type='text'
                name={`flights_${props.flightIndex}_user-time`}
              />
            }
            value={time}
            onChange={() => setTime}
          />
        </div>
        <label
          className='ticket__label ticket__label--time ticket__label--icon-left input-block'
          data-validateable-block
        >
          <select
            className='ticket__input ticket__input--time input-field'
            name={`flights_${props.flightIndex}_time`}
            onChange={e => setTime(e.target.value)}
            required
            data-validateable-input
          >
            {timeOptions}
          </select>
          <div className='input-error'>{t('This field is required')}</div>
        </label>
      </div>
      <label
        className='ticket__label ticket__label--passengers ticket__label--icon-top input-block'
        data-validateable-block
      >
        <select
          className='ticket__input ticket__input--big input-field'
          name={`flights_${props.flightIndex}_pax`}
          required
          data-validateable-input
        >
          <option selected>1</option>
          {paxOptions}
        </select>
      </label>

      <AircraftPicker
        inputName={`flights_${props.flightIndex}_aircraft`}
        maxSelection={1}
        wrapperClass={aircraftPickerDropdownClass}
      />

      {props.onCrossClick && (
        <button
          type='button'
          onClick={props.onCrossClick}
          className='small-circle-button small-circle-button--close ticket-landing__remove'
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        ></button>
      )}
    </div>
  )
}

FlightForm.propTypes = {
  className: PropTypes.string,
  disableFromTo: PropTypes.bool,
  flightIndex: PropTypes.number.isRequired,
  from: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  defaultFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onCrossClick: PropTypes.func,
  onFromChange: PropTypes.func,
  onToChange: PropTypes.func,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  defaultTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  withRightButton: PropTypes.bool,
}

export default FlightForm
